<template>
  <div>
    <van-form>
      <v-text-field
          v-model="meterValue"
          type="number"
          :placeholder="$t('regionalEnergy.sendIndications.enterMeterValue')"
          class="mt-20"
      ></v-text-field>
      <div v-if="showError" class="required-field-text">{{ $t('regionalEnergy.sendIndications.requiredField') }}</div>

      <itserve-button
          :disabled="isSubmitting || !account"
          type="primary"
          :value="$t('buttons.sendIndications')"
          @click="onSubmit"
          class="mt-20 apply-loader"
      ></itserve-button>
    </van-form>

    <simple-dialog
        v-model="showDialog"
        :title="dialogMessage"
        :success="dialogSuccess"
        @change="resetForm"
    >
    </simple-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { Form } from 'vant';
import ItserveButton from '@/components/forms/ItserveButton';
import SimpleDialog from '@/components/content/SimpleDialog';

export default {
  name: "ApiNaftogazTariffmaxForm",
  components: {
    'itserve-button': ItserveButton,
    'simple-dialog': SimpleDialog,
    'van-form': Form
  },
  data() {
    return {
      meterValue: '',
      showDialog: false,
      dialogMessage: '',
      dialogSuccess: true,
      showError: false,
    };
  },
  computed: {
    ...mapState({
      isSubmitting: state => state.ApiNaftogazTariffmax.isSubmitting,
      submitResult: state => state.ApiNaftogazTariffmax.submitResult,
      account: state => state.Auth.account
    })
  },
  methods: {
    ...mapActions({
      sendIndications: 'ApiNaftogazTariffmax/sendApiNaftogazTariffmaxIndications'
    }),
    onSubmit() {
      if (!this.meterValue) {
        this.showError = true;
        return;
      }
      this.showError = false;

      if (!this.account || !this.account.accountNumber || !this.account.lastname) {
        this.$toast.fail(this.$t('regionalEnergy.sendIndications.accountDataMissing'));
        return;
      }

      this.sendIndications(this.meterValue).then(() => {
        if (this.submitResult) {
          if (this.submitResult.status === 'pending') {
            this.dialogMessage = this.$t('regionalEnergy.sendIndications.successfullySent');
            this.dialogSuccess = true;
            this.showDialog = true;
          } else if (this.submitResult.status === false) {
            // Проверяем, содержит ли сообщение информацию об ограничении по времени
            this.dialogSuccess = false;

            if (this.submitResult.message && this.submitResult.message.includes('28 по 5 число')) {
              this.dialogMessage = this.$t('regionalEnergy.sendIndications.timeRestriction');
            } else if (this.submitResult.status_code === "201") {
              this.dialogMessage = this.$t('regionalEnergy.sendIndications.meterAlreadyTransmitted');
            } else {
              // Если другая ошибка, показываем сообщение из ответа
              this.dialogMessage = this.submitResult.message || this.$t('regionalEnergy.sendIndications.unknownError');
            }
            this.showDialog = true;
          }
        }
      });
    },
    resetForm() {
      this.meterValue = '';
      // this.$router.push({ name: "Account" });
    }
  }
};
</script>

<style scoped>
.required-field-text {
  color: #999;
  font-size: 12px;
  margin-top: 5px;
  margin-bottom: 10px;
  text-align: center;
}

.meter-input :deep(.custom-input) {
  font-size: 20px;
  text-align: center;
  height: 50px;
  margin-bottom: 10px;
}

.result-message {
  margin-top: 20px;
}

.success-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

.success-message p {
  margin-top: 10px;
  font-size: 16px;
  color: #07c160;
  font-weight: 500;
}
</style>
